import React, { useEffect } from 'react';

// This component was created as a workaround to address accessibility bugs in fluentUI components.
// Note this was custom built based on the rendered DOM for the existing version of fluentUI, do 
// not use this component in genral to modify non-ant components, as it won't work.
const AccessibleComboBox = (props: any): any => {
    useEffect(() => {
        const elementId = props?.id;
        if (!elementId) {
            return;
        }

        const rootElement = document.getElementById(elementId);
        let id = elementId + "wrapper";

        const domChildrenElement = rootElement?.querySelector("#" + id)?.getElementsByTagName("button");

        if (domChildrenElement?.length) {
            const button = domChildrenElement[0];

            button.removeAttribute("role");
            button.setAttribute("aria-label", "下拉菜单")
        }
    });
    let Component = props?.component;
    return <Component {...props} />
}

export default AccessibleComboBox;